export default {
  SHOW_MESSAGE(state, payload) {
    state.message.text = payload.text
    state.message.color = payload.color
  },
}
